import { useMutation, useQuery, useQueryClient } from "react-query";

const INITIAL_Table_FILTER = { fields: 'decline-rate' };
const STORAGE_KEY = 'Table-filter';

export type TableFilterType = {
  fields: string[];
};

export const useTableFilterQuery = () => useQuery([STORAGE_KEY], () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved ? JSON.parse(saved) : INITIAL_Table_FILTER;
})

export const useTableFilterMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, TableFilterType>(async (filter: TableFilterType) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filter));
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries([STORAGE_KEY]);
    },
  })
};
